import { observer } from 'mobx-react';
import { TitleAgentForm } from './TitleAgentForm';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { Document } from '@roc/feature-types';
import { StandardDialog } from '@roc/ui';

export type TitleAgencyInfoItemProps = {
  open: boolean;
  onClose: () => void;
  showAlert: (message: string, type: 'success' | 'danger') => void;
  document: Document;
};

export const TitleAgencyInfoItem = observer(
  ({ open, onClose, showAlert, document }: TitleAgencyInfoItemProps) => {

    return (
      <> {document?.taskId ? (
        <CustomTaskDialog
          open={open}
          title="Title Agency"
          handleClose={onClose}
          dialogContent={(
            <TitleAgentForm
              closeModal={onClose}
              showAlert={showAlert ?? (() => {})}
            />
            )}
          taskId={document?.taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Title Agency"
          maxWidth="sm"
          handleClose={onClose}
          dialogContent={(
            <TitleAgentForm
              closeModal={onClose}
              showAlert={showAlert ?? (() => {})}
            />
            )}
        />
      )}
      </>
    );
  }
);

export default TitleAgencyInfoItem;
